<script lang="ts">
	import type { Icon, IconProps } from "../../../vite/Icon";
	import LoadingIndicator from "./LoadingIndicator.svelte";

	const {
		icon: IconComponent,
		loading,
		iconAttrs,
		loadingAttrs,
		...rest
	}: IconProps & {
		icon: Icon | undefined | null;
		loading: boolean;
		iconAttrs?: IconProps;
		loadingAttrs?: IconProps;
	} = $props();
</script>

{#if Boolean(IconComponent) || loading}
	<div class={["grid size-min [grid-template-areas:single]", loading && "cursor-wait"]}>
		<div
			class={[
				"[grid-area:single] not-motion-reduce:animate-spin not-motion-reduce:transition-[scale,opacity]",
				loading ? "scale-100 opacity-100" : "scale-0 opacity-0",
			]}
		>
			<LoadingIndicator {...rest} {...loadingAttrs} class={[loadingAttrs?.class, rest.class]} />
		</div>
		{#if IconComponent}
			<div
				class={[
					loading ? "scale-0 opacity-0" : "scale-100 opacity-100",
					"[grid-area:single] not-motion-reduce:transition-[scale,opacity]",
				]}
			>
				<IconComponent {...rest} {...iconAttrs} class={[iconAttrs?.class, rest.class]} />
			</div>
		{/if}
	</div>
{/if}
